(function() {

    // angular.module('iq_common',['ngFileUpload'])
    angular.module('iq_common')
    	.directive("compile", ["$compile",function ($compile) {
            return function (scope, element, attrs) {
                scope.$watch(
                    function (scope) {
                        return scope.$eval(attrs.compile);
                    },
                    function (value) {
                        element.html(value);
                        $compile(element.contents())(scope);
                    }
                );
            };
        }])
    	.directive("iqUse",["$timeout",function($timeout){
    		var relativePath = "svgicon.svg";
    		var relativePathFlag = false;

    		if(/Firefox/.test(navigator.userAgent)){
    			relativePathFlag = true;
    		}
    		else if(/Chrome\/49/.test(navigator.userAgent)){
        		var  relativePath = "svgicon.svg";
        		if(/Linux/.test(navigator.userAgent)){
	      			  relativePath = "svgicon.svg";
	      		}
    			relativePathFlag = true;
    		}
    		else if(/Chrome\/5\d/.test(navigator.userAgent)){
        		var  relativePath = "svgicon.svg";
        		if(/Linux/.test(navigator.userAgent)){
        			  relativePath = "svgicon.svg";
        		}
    			relativePathFlag = true;
    		}
    		else if(/Edge\/12/.test(navigator.userAgent)){
        		var  relativePath = "svgicon.html";
    			//relativePathFlag = true;
    		}

    		return {
    			link:function(scope, iElement, iAttr, ctrl, $transclude){
    				if(relativePathFlag){
        				var use = $(iElement);
        				if(use){
        					var t = use.attr("xlink:href");
        					if(t.indexOf("{{")>=0){
        						$timeout(function(){
        							use.attr("xlink:href", relativePath+scope.$eval(t.replace(/[\{\}]/g,"")));
        						})
        					}else{
            					use.attr("xlink:href", relativePath+use.attr("xlink:href"));

        					}
        				}
    				}
    			}
    		}
    	}])
    	.directive("iqDateSelect",['$ocLazyLoad','$filter',function($ocLazyLoad,$filter){
            var dateFilter = $filter('date');

    		var loadRes = undefined;
    		return {
                require: 'ngModel',
    			link:function(scope,iElement,iAttr,ctrl,$transclude){
    				var date_option = {
    	                    autoclose: true, // 选中关闭
    	                    initialDate: new Date(),
    	                    format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
    	                    weekStart: 1, // 开始星期一
    	                    startView: 'month',
    	                    minView: 'month',
    	                    todayHighlight: true, // 高亮 今天的日期
    	                    enableOnReadonly: true,
    	                    forceParse : false
    	                }
        			if(!loadRes){
            			var lazyLoadPromise = $ocLazyLoad.load({
                            files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
                                '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
                            ]
                        });
        				loadRes = lazyLoadPromise;
        			}
    				var _date_option = date_option;
        			loadRes.then(function(){
        				scope.$watch(iAttr.option,function(cur){
        					_date_option = angular.extend(date_option,cur);
        					iElement.attr("autocomplate","off");
            				iElement.datetimepicker(_date_option).on("changeDate",function(){
            					iElement.focus().blur();
            				});
        				})
        			})
        			if(iAttr.dateFilter !==undefined){
                        function formatter(value) {
                        	if(value){
                        		console.log(value);
                        		return dateFilter(value, _date_option.format.replace(/m/g,"M"));
//                        		return value.format(_date_option.format.toUpperCase()); // format
                        	}else{
                        		return "";
                        	}
                        }
                        ctrl.$formatters.push(formatter);
        			}

    				function parser() {
    					var tmp = _date_option.format.toUpperCase();
    					var value = ctrl.$viewValue;

						var _time = moment(value,tmp,true);
						if(_time.isValid()){
						}else{
							ctrl.$viewValue = undefined;
							ctrl.$modelValue = undefined;
							_time = undefined;
							ctrl.$valid = false;
							if(!ctrl.$$rawModelValue){
								iElement.val("");
							}
							return undefined;
						}
						if(iAttr.dateFilter !==undefined){
							return _time.toDate();
						}
						return ctrl.$viewValue;
					}
					ctrl.$options = { updateOn: 'blur focus change'}
        			ctrl.$parsers.push(parser);
    			}
    		}
    	}])
    	.directive("iqTimeSelect",['$ocLazyLoad',function($ocLazyLoad){
    		var loadRes = undefined;
    		return {
                require: 'ngModel',
    			link:function(scope,iElement,iAttr,ctrl,$transclude){
//    	        		      step: options.step || 30,
//    	        		      begin: options.begin || 8,
//    	        		      max: options.max || false

        			if(!loadRes){
            			var lazyLoadPromise = $ocLazyLoad.load({
                            files: ['/lib/iquicker/time-select.js']
                        });
        				loadRes = lazyLoadPromise;
        			}
        			loadRes.then(function(){
        				if(iAttr.timeoption){

        					timeSelect(iElement,angular.copy(scope.$eval(iAttr.timeoption)));
        				}
        				else{
        					timeSelect(iElement);
        				}
        			})
					function parser() {
						var _time = moment(ctrl.$viewValue,"HH:mm",true);
						if(_time.isValid()){
						}else{
							ctrl.$viewValue = "";
							ctrl.$modelValue = "";
							ctrl.$valid = false;
						}
						return ctrl.$viewValue;
					}
					ctrl.$options = { updateOn: 'blur focus'}
        			ctrl.$parsers.push(parser);
    			}
    		}
    	}])
        .directive("iqDateTimePicker",[function(){

        	return {
        		scope:{
        			xcdate:"=date",
        			xctime:"=time",
        			xcdatetime:"=datetime",
        			dateoption:"=dateoption"
        		},
        		template:"<input class='form-control date-input' iq-date-select option='dateoption' ng-model='xcdate'><input class='form-control time-input' iq-time-select ng-model='xctime'>",
        		link:function(scope,iElement,iAttr,ctrl,$transclude){
                	var date_option = {
                            autoclose: true, // 选中关闭
                            initialDate: new Date(),
                            format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                            weekStart: 1, // 开始星期一
                            startView: 'month',
                            minView: 'month',
                            todayHighlight: true, // 高亮 今天的日期
                            enableOnReadonly: true,
                            forceParse : false
                        }
    				scope.$watch("dateoption",function(cur){
    					_date_option = angular.extend(date_option,cur);
    				})
        				scope.$watch("xcdate",function(cur){
        					var m =  moment(scope.xcdate+" "+scope.xctime,_date_option.format.toUpperCase()+" HH:mm");
        					if(m.isValid()){
            					scope.xcdatetime =m.toDate();
        					}
        				})
        				scope.$watch("xctime",function(cur){
        					var m =  moment(scope.xcdate+" "+scope.xctime,_date_option.format.toUpperCase()+" HH:mm");
        					if(m.isValid()){
            					scope.xcdatetime =m.toDate();
        					}
        				})
        		}
        	}
        }])
        .directive("iqDateFilter", ['$filter', function($filter) {

            var dateFilter = $filter('date');
            return {
                require: 'ngModel',
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                    var option = {
                        format: 'yyyy-MM-dd', // 默认样式
                        ignoreTime: true // 默认不考虑时间
                    };
                    if (iAttr.dpoption) {
                        scope.$watch(iAttr.dpoption, function ngShowWatchAction(_option) {
                            option = angular.extend({
                                format: 'yyyy-MM-dd', // 默认样式
                                ignoreTime: true
                            }, _option);
                            if (option.ignoreTime == true) {
                                option.format = option.format.replace(/m/g, "M"); // 不考虑时间，与datepicker对接
                            }else{
                            	option.format = option.format.replace(/i/g, "m");
                            }
                        })
                    }

                    function formatter(value) {
                        return dateFilter(value, option.format); // format
                    }

                    function parser() {
                        var _date = parseDate(ctrl.$viewValue);

                        if (_date.getTime() == NaN) {
                            if (option.def_date === "now") {
                                return new Date();
                            } else {
                                if (angular.isDate(option.def_date)) {
                                    return option.def_date;
                                } else {
                                    return parseDate(option.def_date);
                                }
                            }
                        }
                        return _date;
                    }

                    ctrl.$formatters.push(formatter);

                    ctrl.$parsers.push(parser);
                }
            }
        }])
        .directive("ngDatepicker", ['$ocLazyLoad', function($ocLazyLoad) {

            return {
                require: '?ngModel',
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                	var option = {
                            autoclose: true, // 选中关闭
                            initialDate: new Date(),
                            format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                            weekStart: 1, // 开始星期一
                            startView: 'month',
                            minView: 'month',
                            todayHighlight: true, // 高亮 今天的日期
                            enableOnReadonly: true,
                            forceParse : false
                        }
                	if(ctrl){
                		ctrl.$options = {
                			updateOn: 'blur'
                		}
                	}
                	if(ctrl && iAttr.iqDateFilter === undefined){
                        function parser() {

                        	var re = new RegExp(option.format.replace(/[ymdhis]/gi,"\\d"));
                        	re.ignoreCase = true;

                            if(ctrl.$viewValue.match(re)){
                                return ctrl.$viewValue;
                            }
                            else{
                            	iElement.val("");
                            	return null
                            }
                        }
                        ctrl.$parsers.push(parser);

                	}
                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
                            '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
                        ]
                    }).then(function() {
                        if (iAttr.dpoption) {
                            scope.$watch(iAttr.dpoption, function ngShowWatchAction(_option) {

                                option = angular.extend(option, _option);

                                if(option.format.search(/[ymd]/i)<0){
                                	var container = $("#datetimepicker-only-table");
                                	if(container.length<1){
                                		container = $("<div>").attr("id","datetimepicker-only-table")
                                			.addClass("datetimepicker-only-table")
                                			.css("position","absolute").appendTo("body");
                                	}
                                	option.container = "#datetimepicker-only-table";
                                }
                                var dp = iElement.datetimepicker(option);

                            	if(ctrl && iAttr.iqDateFilter === undefined){
	                                dp.on("changeDate", function(v){
	                                	scope.$apply(function(){
	                                		iElement.attr("autocomplate","off");
	                                    	iElement.trigger("focus");
	                                    	iElement.trigger("blur");
//	                                		scope.$eval(iAttr.ngModel +"= '"+ iElement.val()+"'");
	                                	})
	                                });
                            	}else if(iAttr.iqDateFilter !== undefined){
	                                dp.on("changeDate", function(v){
	                                	scope.$apply(function(){
	                                		iElement.attr("autocomplate","off");
	                                    	iElement.trigger("focus");
	                                    	iElement.trigger("blur");
//	                                		scope.$eval(iAttr.ngModel +"= parseDate('"+ iElement.val()+"')");
	                                	})
	                                });
                            	}
                                	//iElement
//
                            })
                        } else {

                            var dp = iElement.datetimepicker(option);
                        	if(ctrl && iAttr.iqDateFilter === undefined){
                                dp.on("changeDate", function(v){
                                	scope.$apply(function(){
                                		iElement.attr("autocomplate","off");
                                    	iElement.trigger("focus");
                                    	iElement.trigger("blur");
//                                		scope.$eval(iAttr.ngModel +"= '"+ iElement.val()+"'");
                                	})
                                });
                        	}else if(iAttr.iqDateFilter !== undefined){
                                dp.on("changeDate", function(v){
                                	scope.$apply(function(){
                                		iElement.attr("autocomplate","off");
                                    	iElement.trigger("focus");
                                    	iElement.trigger("blur");
//                                		scope.$eval(iAttr.ngModel +"= parseDate('"+ iElement.val()+"')");
                                	})
                                });
                        	}
                        }
                    	if(ctrl ){
	                        scope.$watch(iAttr.ngModel,function(cur){
	                        	iElement.datetimepicker("update",cur);
	                        })
                    	}
                        scope.$on("$destroy",function(){
                        	iElement.datetimepicker("remove");
                        })
                    })
                    return lazyLoadPromise;
                }
            }
        }])
        .directive("ngDaterange", ["$ocLazyLoad", function($ocLazyLoad) {
            return {
                link: function(scope, iElement, iAttr, ctrl, $transclude) {


                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
                            '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
                        ]
                    }).then(function() {
                        function init(_option) {
                            var option = angular.extend({
                                autoclose: true, // 选中关闭
                                format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                                weekStart: 1, // 开始星期一
                                startView: 'month',
                                minView: 'month',
                                todayHighlight: true, // 高亮 今天的日期
                                enableOnReadonly: true,
                                forceParse : false
                            }, _option);

                            var start = $('input:first', iElement).datetimepicker(option);
                            var end = $('input[type!="button"]:last', iElement).datetimepicker(option);

                            var changeRange = function() {
                                var map = [];
                                if (end.val() < start.val()) {
                                    end.val(start.val());
                                    end.trigger("change");
                                }
                                map.push(start.datetimepicker("getDate") || new Date());
                                map.push(end.datetimepicker("getDate") || new Date());
                                start.datetimepicker("setRange", map);
                                //                                start.datetimepicker("setEndDate", end.datetimepicker("getDate"));
                                end.datetimepicker("setStartDate", start.datetimepicker("getDate"));
                                end.datetimepicker("setRange", map);
                            }
                            start.on("changeDate", changeRange);
                            end.on("changeDate", changeRange);
                            start.on("change", changeRange);
                            end.on("change", changeRange);
                            changeRange();
                        }
                        if (iAttr.dpoption) {
                            scope.$watch(iAttr.dpoption, function ngShowWatchAction(_option) {
                                init(_option);
                            })
                        } else {
                            init();
                        }
                    })
                    return lazyLoadPromise;
                }
            }
        }])
        .directive('pageTitle', ["$rootScope", "$timeout", function($rootScope, $timeout) {
            return {
                link: function($scope, element, $attrs) {
                    var listener = function(event, toState, toParams, fromState, fromParams) {
                    	var preFix = $attrs.preFix || 'iQuicker'
                        var title = preFix;
                        if (toState.data && toState.data.pageTitle){
                        	title = preFix + ' | ' + toState.data.pageTitle;
                        }
                        $timeout(function() {
                            element.text(title);
                        });
                    };
                    $rootScope.$on('$stateChangeStart', listener);
                }
            }
        }])
        .directive('icheck', ["$ocLazyLoad", function($ocLazyLoad) {

            /**
             * icheck - Directive for custom checkbox icheck 自动识别icheck加载
             */
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function($scope, element, $attrs, ngModel) {

                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/iCheck/custom.css',
                            '/lib/plugins/iCheck/icheck.js'
                        ]
                    }).then(function() {
                        var value;
                        value = $attrs['value'];

                        $scope.$watch($attrs['ngModel'], function(newValue) {
                            $(element).iCheck('update');
                        })
                        if ($attrs['ngDisabled']) {
                            $scope.$watch($attrs['ngDisabled'], function(newValue) {
                                $(element).iCheck('update');
                            })
                        }
                        if ($attrs['indeterminate']) {
                            $scope.$watch($attrs['indeterminate'], function(newValue) {
                                $(element).attr("indeterminate",newValue).iCheck('update');
                            })
                        }

                        return $(element).iCheck({
                            checkboxClass: 'icheckbox_square',
                            radioClass: 'iradio_square'

                        }).on('ifChanged', function(event) {
                            if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                                $scope.$apply(function() {
                                    return ngModel.$setViewValue(event.target.checked);
                                });
                            }
                            if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            	//单选要选中才更新值
                            	if(element[0]&&element[0].checked){
                                    return $scope.$apply(function() {
                                        return ngModel.$setViewValue(value);
                                    });
                            	}
                            }
                        });
                    });
                    return lazyLoadPromise;
                }
            };
        }])
        .directive("iqFileUpload",function($ocLazyLoad){

            return {
                restrict: 'A',
                scope:{
                	validate:"=validate",
                	success:"=success"
                },
                link: function($scope, element, $attrs, ngModel) {
                	var path = $attrs.path;
                	$ocLazyLoad.load(plugin_files["jqueryFileupload"]).then(function(){
                		element.fileupload({
            				dateType:"text",
            				forceIframeTransport:old_browser.IE && old_browser.version <= 9,
            				url: path,
            				add: function (e, data) {
            					data.url = $attrs.path;
            					if($scope.validate){
            						if(false === $scope.validate(e,data)){
            							return
            						}
            					}
            				    var jqXHR = data.submit()
            				    .success(function (result, textStatus, jqXHR) {
            				    	var _result = result;
            						        var size = "";
            						var filetype = "";
            						if(old_browser.IE && old_browser.version <= 9){
            							_result = new Function('return '+$(result[0].body.innerHTML).text())();
            				        }
            						if(_result.success == "true" || _result.success == true){
                    					if($scope.success){
                    						$scope.success(result);
                    					}
            						}else{
            							alert("文件上传失败");
            						}
            			        })
            			    }
            			})
                	})
                }
            }
        })

        .directive('iqSwitch',['$iq_server','$iq_http','$ocLazyLoad',function($iq_server,$iq_http,$ocLazyLoad){
                	return {
                        restrict: 'AE',
                        templateUrl : '/components/checkbox/checkbox.html',
                        link: function(scope, ele, attr) {
                          $ocLazyLoad.load(['/components/checkbox/checkbox.css'])
                        }
                	}
        }])

        .directive('imgUpload',['$iq_server','$iq_http',function($iq_server,$iq_http){
        	return {
                restrict: 'AE',
                scope:{
                	id: '=id',
                	picid: '=picid',
                	moduleurl: '=moduleurl',
                	param: '=param',
                	pathname: '=pathname'
                },
                templateUrl : '/home/templates/common/iq_imgupload.html',
                controller:function($scope,$timeout) {

                	$scope.pathUrl = $iq_server.server()+"common/file/display/"+$scope.pathname+"/path/";

                	function showUplod(type) {
                		$("#" + type + "Preview").addClass('hide');
                		$("#" + type + "Upload").removeClass('hide');
                	}
                	function showPreview(type) {
                		$("#" + type + "Upload").addClass('hide');
                		$("#" + type + "Preview").removeClass('hide');
                	}

                	$timeout(function(){

                	$("#"+$scope.id).fileupload({
        				dateType:"text",
        				forceIframeTransport:old_browser.IE && old_browser.version <= 9,
        				url: $iq_server.server() + $scope.moduleurl,
        				add: function (e, data) {
        					var fileName = data.files[0].name;
        					var fileType = fileName.substring(fileName.indexOf('.')+1,fileName.length);
        					if(fileType != 'bmp' && fileType != 'BMP' && fileType != 'svg' && fileType != 'SVG'
                    			&& fileType != 'jpg' && fileType != 'JPG' && fileType != 'jpeg'
                    			&& fileType != 'JPEG' && fileType != 'gif' && fileType != 'GIF'
                    			&& fileType != 'png' && fileType != 'PNG'){
        						$iq_popup.alert("对不起，您只能上传bmp,svg,jpg,jpeg,gif,png类型的文件！",3,'warn');
        						return;
        					}
        				    var jqXHR = data.submit().success(function (result, textStatus, jqXHR) {
        				    	var _result = result;
        						if(old_browser.IE && old_browser.version <= 9){
        							_result = new Function('return '+$(result[0].body.innerHTML).text())();
        							console.log("_result",_result.data.fileId);
        				        }

        						console.log("_result",_result);

        						if(_result.success == "true" || _result.success == true){
        							$scope.$apply(function(){
        								$scope.picid=_result.data.fileId;
        								$scope.param = _result.data;
        								showPreview($scope.id);

        							})
        						}else{
        							alert("文件上传失败");
        						}
        			        })
        			    }
        			})
                	})

        			/*var removeImg = function(param, success) {
                		var func = {
                				success : function(re) {
                					if (success && re.data.success) {
                						success();
                					} else {
                						$iq_popup.alert(re.data.message, 3, 'fail');
                					}
                				}
                		}
                		var params = {
                				method : "POST",
                				url : $iq_server.server() + $scope.moduleurl,
                				params : param
                		}
                		$iq_http.http(params, func);
                	}*/
        			$scope.removeImg = function(type, mypic) {
						showUplod(type);
						var fileName = null;
						$scope.picid = "";
						$("#" + type).val('');
//						if ($scope.picid == mypic) {
//							fileName = $scope.picid;
//						}
//						if (fileName) {
//							removeImg({
//								fileName :fileName
//							}, function() {
//								if ($scope.picid == mypic) {
//									$scope.picid = null;
//								}
//								$("#" + type).val('');
//
//							});
//						}

					}

                }

        	}
        }])
        .directive('pageTitle', ["$rootScope", "$timeout", function($rootScope, $timeout) {
            return {
                link: function($scope, element, $attrs) {
                    var listener = function(event, toState, toParams, fromState, fromParams) {
                        var preFix = $attrs.preFix || 'ITSM';
                        var title = preFix;
                        if (toState.data && toState.data.pageTitle) {
                            title = preFix + ' | ' + toState.data.pageTitle;
                        }
                        $timeout(function() {
                            element.text(title);
                        });
                    };
                    $rootScope.$on('$stateChangeStart', listener);
                }
            };
        }])
        .directive('itsmScroller', function($ocLazyLoad) {
            //滚动条指令  @author zhangwen
            return {
				/*
				 enablescrollButtons:boolean       //滚动条上下方按钮是否可用
				 theme:String ['dark/light','dark/light-2','dark/light-thick','dark/light-thin']
				 axis:String  ['x','y','xy']       //滚动条的方向
				 scrollbarPosition:String ['inside','outside'] //滚动条所处的位置
				 autoHideScrollbar:boolean         //是否自动隐藏滚动条
				 snapAmount：int                   //滚动条一次性滑动的单元像素数，默认为平滑移动
				 enableMouse:boolean               //是否允许鼠标滑轮滚动
				 enableKeyboard:boolean            //是否允许键盘方向键滚动

				 */
                restrict: 'A',
                scope: false,
                link: function(scope, element, attrs) {

                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/custom-scroller/css/jquery.mCustomScrollbar.css', '/lib/plugins/custom-scroller/jquery.mCustomScrollbar.concat.min.js']
                    }).then(function() {

                        //将属性与默认属性匹配
                        var p = angular.extend({
                            //设置默认值
                            enablescrollButtons: true,
                            theme: 'dark',
                            axis: 'y',
                            scrollbarPosition: 'outside',
                            autoHideScrollbar: true,
                            snapAmount: 1,
                            enableMouse: true,
                            enableKeyboard: true
                        }, scope[attrs.property]);

                        //设置滚动条的样式
                        element.mCustomScrollbar({
                            scrollButtons: {
                                enable: p.enablescrollButtons
                            },
                            theme: p.theme,
                            axis: p.axis,
                            scrollbarPosition: p.scrollbarPosition,
                            autoHideScrollbar: p.autoHideScrollbar,
                            snapAmount: p.snapAmount,
                            mouseWheel: {
                                enable: p.enableMouse
                            },
                            keyboard: {
                                enable: p.enableKeyboard
                            },
                            callbacks: scope[attrs.callback]
                        });
                    });
                }
            };
        })
        .directive('icheck', ["$ocLazyLoad", function($ocLazyLoad) {

            /**
             * icheck - Directive for custom checkbox icheck 自动识别icheck加载
             */
            return {
                restrict: 'A',
                require: "?ngModel",
                link: function($scope, element, $attrs, ngModel) {

                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/iCheck/custom.css',
                            '/lib/plugins/iCheck/icheck.js'
                        ]
                    }).then(function() {
                        var value = $attrs.value;

                        if ($attrs.ngModel) {
                            $scope.$watch($attrs.ngModel, function(newValue) {
                                $(element).iCheck('update');
                            });
                        }
                        if ($attrs.ngDisabled) {
                            $scope.$watch($attrs.ngDisabled, function(newValue) {
                                $(element).iCheck('update');
                            });
                        }

                        var changeModel = function(event) {
                            if ($(element).attr('type') === 'checkbox' && $attrs.ngModel) {
                                $scope.$apply(function() {
                                    return ngModel.$setViewValue(event.target.checked);
                                });
                            }
                            if ($(element).attr('type') === 'radio' && $attrs.ngModel) {
                                //单选要选中才更新值
                                if (element[0] && element[0].checked) {
                                    return $scope.$apply(function() {
                                        return ngModel.$setViewValue(value);
                                    });
                                }
                            }
                        };

                        var change = function(event) {
                            if ($attrs.ngModel) {
                                changeModel(event);
                            }
                        };

                        return $(element).iCheck({
                            checkboxClass: 'icheckbox_square',
                            radioClass: 'iradio_square'

                        }).on('ifChanged', change);
                    });
                    return lazyLoadPromise;
                }
            };
        }])
        .directive('dcDateSelect', function($ocLazyLoad, $filter) {
            var dateFilter = $filter('date');
            var loadRes = undefined;
            return {
                require: 'ngModel',
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                    var date_option = {
                        autoclose: true, // 选中关闭
                        initialDate: new Date(),
                        format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                        weekStart: 1, // 开始星期一
                        startView: 'month',
                        minView: 'month',
                        todayHighlight: true, // 高亮 今天的日期
                        enableOnReadonly: true,
                        forceParse: false
                    };
                    if (!loadRes) {
                        var lazyLoadPromise = $ocLazyLoad.load({
                            files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
                                '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
                            ]
                        });
                        loadRes = lazyLoadPromise;
                    }
                    var _date_option = date_option;
                    loadRes.then(function() {
                        scope.$watch(iAttr.option, function(cur) {
                            _date_option = angular.extend(date_option, cur);
                            iElement.attr("autocomplate", "off");
                            iElement.datetimepicker(_date_option).on("changeDate", function() {
                                iElement.focus().blur();
                            });
                        });
                    });
                    if (iAttr.dateFilter !== undefined) {
                        var formatter = function(value) {
                            if (value) {
                                return dateFilter(value, _date_option.format.replace(/m/g, "M"));
                            } else {
                                return "";
                            }
                        };
                        ctrl.$formatters.push(formatter);
                    }

                    function parser() {
                        var tmp = _date_option.format.toUpperCase();
                        var value = ctrl.$viewValue;
                        var _time = moment(value, tmp, true);
                        if (_time.isValid()) {} else {
                            ctrl.$viewValue = undefined;
                            ctrl.$modelValue = undefined;
                            _time = undefined;
                            ctrl.$valid = false;
                            if (!ctrl.$$rawModelValue) {
                                iElement.val("");
                            }
                            return undefined;
                        }
                        if (iAttr.dateFilter !== undefined) {
                            return _time.toDate();
                        }
                        return ctrl.$viewValue;
                    }

                    ctrl.$options = {
                        updateOn: 'blur focus change'
                    };
                    ctrl.$parsers.push(parser);
                }
            };
        })
        .directive('dcTimeSelect', function($ocLazyLoad) {
            var loadRes = undefined;
            return {
                require: 'ngModel',
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                    if (!loadRes) {
                        var lazyLoadPromise = $ocLazyLoad.load({
                            files: ['/lib/dc/time-select.js']
                        });
                        loadRes = lazyLoadPromise;
                    }
                    loadRes.then(function() {
                        if (iAttr.timeoption) {
                            timeSelect(iElement, angular.copy(scope.$eval(iAttr.timeoption)));
                        } else {
                            timeSelect(iElement);
                        }
                    });

                    function parser() {
                        var _time = moment(ctrl.$viewValue, "HH:mm", true);
                        if (_time.isValid()) {} else {
                            ctrl.$viewValue = "";
                            ctrl.$modelValue = "";
                            ctrl.$valid = false;
                        }
                        return ctrl.$viewValue;
                    }

                    ctrl.$options = {
                        updateOn: 'blur focus'
                    };
                    ctrl.$parsers.push(parser);
                }
            };
        })
        .directive('dcDateTimeSelect', function() {
            return {
                scope: {
                    xcdate: "=date",
                    xctime: "=time",
                    xcdatetime: "=datetime",
                    dateoption: "=dateoption",
                    xcdisabled: "=disabled"
                },
                template: "<input class='form-control date-input' ng-disabled='xcdisabled' dc-date-select option='dateoption' ng-model='xcdate'><input class='form-control time-input'  ng-disabled='xcdisabled' dc-time-select ng-model='xctime'>",
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                    var date_option = {
                        autoclose: true, // 选中关闭
                        initialDate: new Date(),
                        format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                        weekStart: 1, // 开始星期一
                        startView: 'month',
                        minView: 'month',
                        todayHighlight: true, // 高亮 今天的日期
                        enableOnReadonly: true,
                        forceParse: false
                    };
                    scope.$watch("dateoption", function(cur) {
                        _date_option = angular.extend(date_option, cur);
                    });
                    scope.$watch("xcdate", function(cur) {
                        var m = moment(scope.xcdate + " " + scope.xctime, _date_option.format.toUpperCase() + " HH:mm");
                        if (m.isValid()) {
                            scope.xcdatetime = m.toDate();
                        }
                    });
                    scope.$watch("xctime", function(cur) {
                        var m = moment(scope.xcdate + " " + scope.xctime, _date_option.format.toUpperCase() + " HH:mm");
                        if (m.isValid()) {
                            scope.xcdatetime = m.toDate();
                        }
                    });
                }
            };
        })
        .directive('dcDateRange', function($ocLazyLoad) {
            return {
                link: function(scope, iElement, iAttr, ctrl, $transclude) {
                    var lazyLoadPromise = $ocLazyLoad.load({
                        files: ['/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.js',
                            '/lib/plugins/bootstrap-datetimepicker/bootstrap-datetimepicker.css'
                        ]
                    }).then(function() {
                        function init(_option) {
                            var option = angular.extend({
                                autoclose: true, // 选中关闭
                                format: 'yyyy-mm-dd', // 默认样式 ，mm小写是数字 大写是中文
                                weekStart: 1, // 开始星期一
                                startView: 'month',
                                minView: 'month',
                                todayHighlight: true, // 高亮 今天的日期
                                enableOnReadonly: true,
                                forceParse: false
                            }, _option);
                            var start = $('input:first', iElement).datetimepicker(option);
                            var end = $('input[type!="button"]:last', iElement).datetimepicker(option);
                            var changeRange = function() {
                                var map = [];
                                if (end.val() < start.val()) {
                                    end.val(start.val());
                                    end.trigger("change");
                                }
                                map.push(start.datetimepicker("getDate") || new Date());
                                map.push(end.datetimepicker("getDate") || new Date());
                                start.datetimepicker("setRange", map);
                                //                                start.datetimepicker("setEndDate", end.datetimepicker("getDate"));
                                end.datetimepicker("setStartDate", start.datetimepicker("getDate"));
                                end.datetimepicker("setRange", map);
                            };
                            start.on("changeDate", changeRange);
                            end.on("changeDate", changeRange);
                            start.on("change", changeRange);
                            end.on("change", changeRange);
                            changeRange();
                        }

                        if (iAttr.dpoption) {
                            scope.$watch(iAttr.dpoption, function ngShowWatchAction(_option) {
                                init(_option);
                            });
                        } else {
                            init();
                        }
                    });
                    return lazyLoadPromise;
                }
            };
        })
        .directive('itsmTimepicker', function() {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: '../templates/common/itsm_timepicker.html',
                link: function($scope, iElm, iAttrs) {
                    var hourScroll, minScroll, secScroll;
                    $scope.time = {
                        hour: '00',
                        min: '00',
                        sec: '00'
                    }
                    $scope.timestr = '00:00:00';
                    //时间滚轮是否显示的标志位
                    $scope.isShow = false;
                    var y = y || 0;
                    //设置小时的滚动条
                    hourScroll = new IScroll('#itsm-timepicker-hourwrapper', {
                        mouseWheel: true,
                        disableMouse: true
                    });
                    hourScroll.on("scrollEnd", function() {

                        //如果位置没有变化，并且确定该位置不是最顶部或者最底部
                        if (hourScroll.y % 40 == 0 && hourScroll.y != -920 && hourScroll.y != 0) {
                            return
                        }
                        var i = ((0 - hourScroll.y) / 40).toFixed(0);
                        y = i * 40;
                        //在angular框架之外强制执行代码！

                        hourScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                        $scope.$apply(function() {
                            $scope.time.hour = i;
                            if ($scope.time.hour.toString().length === 1) {
                                $scope.time.hour = '0' + i;
                            }
                            $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                        });
                    });
                    var hourwrapper = document.querySelector('#itsm-timepicker-hourwrapper');
                    var ul = hourwrapper.querySelector('ul');
                    var lis = ul.getElementsByTagName("li");
                    hourClick(hourwrapper, ul, lis);
                    //分钟的滚动条
                    var minwrapper = document.querySelector('#itsm-timepicker-minwrapper');
                    var ul = minwrapper.querySelector('ul');
                    var lis = ul.getElementsByTagName("li");
                    minClick(hourwrapper, ul, lis)
                    minScroll = new IScroll('#itsm-timepicker-minwrapper', {
                        mouseWheel: true
                    });
                    minScroll.on("scrollEnd", function() {
                        //如果位置没有变化，则跳出循环
                        if (minScroll.y % 40 == 0 && minScroll.y != -2360 && minScroll.y != 0) {
                            return
                        }
                        var i = ((0 - minScroll.y) / 40).toFixed(0);
                        var y = i * 40;
                        $scope.time.min = i;
                        minScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                        //在angular框架之外强制执行代码！
                        $scope.$apply(function() {
                            $scope.time.min = i;
                            if ($scope.time.min.toString().length === 1) {
                                $scope.time.min = '0' + i;
                            }
                            $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                        });

                    });
                    //秒的滚动条
                    var secwrapper = document.querySelector('#itsm-timepicker-secwrapper');
                    var ul = secwrapper.querySelector('ul');
                    var lis = ul.getElementsByTagName("li");
                    secClick(hourwrapper, ul, lis)
                    secScroll = new IScroll('#itsm-timepicker-secwrapper', {
                        mouseWheel: true
                    });
                    secScroll.on("scrollEnd", function() {
                        //如果位置没有变化，则跳出循环
                        if (secScroll.y % 40 == 0 && secScroll.y != -2360 && secScroll.y != 0) {
                            return;
                        }
                        var i = ((0 - secScroll.y) / 40).toFixed(0);
                        var y = i * 40;
                        $scope.time.sec = i;
                        secScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                        $scope.$apply(function() {
                            $scope.time.sec = i;
                            if ($scope.time.sec.toString().length === 1) {
                                $scope.time.sec = '0' + i;
                            }
                            $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                        });

                    });

                    //鼠标点击事件-小时
                    function hourClick(hourwrapper, ul, lis) {
                        var liHeight = lis[5].offsetHeight;
                        for (var j = 0; j < lis.length; j++) {
                            lis[j].id = j - 2;
                            lis[j].onclick = function(e) {
                                var liId = e.target.id;
                                if (liId < 0 || liId > 23) {
                                    return
                                } else {
                                    var id = Math.ceil(y / 40)
                                    newId = liId - id;
                                    distance = -newId * liHeight;
                                    y = -distance + y;
                                    $scope.$apply(function() {
                                        $scope.time.hour = liId;
                                        if ($scope.time.hour.toString().length === 1) {
                                            $scope.time.hour = '0' + liId;
                                        }
                                        $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                                    });
                                    hourScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                                }
                            }
                        }
                    }
                    //鼠标点击事件-分钟
                    function minClick(hourwrapper, ul, lis) {
                        var liHeight = lis[5].offsetHeight;
                        for (var j = 0; j < lis.length; j++) {
                            lis[j].id = j - 2;
                            lis[j].onclick = function(e) {
                                var liId = e.target.id;
                                if (liId < 0 || liId > 59) {
                                    return
                                } else {
                                    var id = Math.ceil(y / 40)
                                    newId = liId - id;
                                    distance = -newId * liHeight;
                                    y = -distance + y;
                                    $scope.$apply(function() {
                                        $scope.time.min = liId;
                                        if ($scope.time.min.toString().length === 1) {
                                            $scope.time.min = '0' + liId;
                                        }
                                        $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                                    });
                                    minScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                                }
                            }
                        }
                    }
                    //鼠标点击事件-分钟
                    function secClick(hourwrapper, ul, lis) {
                        var liHeight = lis[5].offsetHeight;
                        for (var j = 0; j < lis.length; j++) {
                            lis[j].id = j - 2;
                            lis[j].onclick = function(e) {
                                var liId = e.target.id;
                                if (liId < 0 || liId > 59) {
                                    return
                                } else {
                                    var id = Math.ceil(y / 40)
                                    newId = liId - id;
                                    distance = -newId * liHeight;
                                    y = -distance + y;
                                    $scope.$apply(function() {
                                        $scope.time.sec = liId;
                                        if ($scope.time.sec.toString().length === 1) {
                                            $scope.time.sec = '0' + liId;
                                        }
                                        $scope.timestr = $scope.time.hour + ':' + $scope.time.min + ':' + $scope.time.sec;
                                    });
                                    secScroll.scrollTo(0, -y, 1000, IScroll.utils.ease.circular);
                                }
                            }
                        }
                    }
                    //点击显示时间滚轮的方法
                    $scope.show = function() {
                        $scope.isShow = !$scope.isShow;
                    }
                    $(".itsm-timepicker-input").blur(function() {
                        $scope.$apply(function() {
                            $scope.isShow = !$scope.isShow;
                        });

                    })

                    document.addEventListener('touchmove', function(e) {
                        e.preventDefault();
                    }, false);

                }
            }
        })
        .directive("dcFileUpload", function (Upload,dcFile) {
            return {
                restrict: 'AE',
                require: "dcFileUpload",
                replace: true,
                templateUrl: '/components/fileupload.html',
                scope: {
                    "ids": "=dcFileUpload",
                    "readonly": "=?readonly",
                    "label": "=sdlabel"
                },
                controller:function ($scope) {

                  var array_id = [];
                  $scope.uploadingList = [];
                  $scope.list = [];
                  //根据id从后台加载文件
                  var loadFile = function (fileId, i) {
                      $scope.list[i] = null;
                      dcFile.getById(fileId).then(function (file) {
                          $scope.list[i] = file;
                      }, function (err) {
                          $scope.list[i] = {
                              error: "file error"
                          };
                          console.log(err);
                      });
                  };
                  //遍历list,获取id列表，生成ids字符串
                  var listToIds = function () {
                      array_id = [];
                      for (var i = 0; i < $scope.list.length; i++) {
                          array_id.push($scope.list[i].id);
                      }
                      $scope.ids = array_id.join(";");
                  };
                  //上传文件后添加id
                  var appendIds = function (id) {
                      array_id.push(id);
                      $scope.ids = array_id.join(";");
                  };
                  $scope.$watch("ids", function () {
                      $scope.list = [];
                      if ($scope.ids) {
                          array_id = $scope.ids.split(";");
                          for (var i = 0; i < array_id.length; i++) {
                              loadFile(array_id[i], i);
                          }
                      } else {
                          $scope.ids = "";
                      }
                  });
                  var uploadFile = function (file) {
                      var uploadingData = {
                          progressPercentage: 0,
                          status: "uploading",
                          fileName: file.name,
                          fileSize: file.size
                      };
                      $scope.uploadingList[$scope.uploadingList.length] = uploadingData;

                      uploadingData.xhr = dcFile.uploadFile(file);
                      uploadingData.xhr.then(function (resp) {
                          if (uploadingData.status === "uploading") {
                              if (resp.data) {
                                  appendIds(resp.data.item.id);
                                  var index = $scope.uploadingList.indexOf(uploadingData);
                                  $scope.uploadingList.splice(index, 1);
                                  // uploadingData.status = "success";
                              } else {
                                  uploadingData.status = "error";
                                  uploadingData.error = "上传失败";
                              }
                          }
                      }, function (resp) {
                          uploadingData.status = "error";
                          uploadingData.error = "上传失败";
                      }, function (evt) {
                          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                          uploadingData.progressPercentage = progressPercentage;
                      });
                  };
                  $scope.remove = function (fileItem) {
                      var index = $scope.list.indexOf(fileItem);
                      $scope.list.splice(index, 1);
                      //ids更新
                      listToIds();
                  };
                  $scope.removeUploading = function (fileItem) {
                      if (fileItem.status === "uploading") {
                          fileItem.xhr.abort();
                          fileItem.status = "cancel";
                      }
                      var index = $scope.uploadingList.indexOf(fileItem);
                      $scope.uploadingList.splice(index, 1);
                  };
                  $scope.uploadFiles = function (files) {
                      if (files && files.length) {
                          for (var i = 0; i < files.length; i++) {
                              uploadFile(files[i]);
                          }
                      }
                  };
                }
            };
        })
        .service("dcFile", function (Upload,$http, $q) {
          var list = {};
          return {
              uploadFile: function (file) {
                  var p = Upload.upload({
                      // "url": dc_config.apiPath() + '/file',
                      "url": '/file',
                      "data": {
                          'file': file
                      }
                  });
                  p.then(function (res) {
                      if (res.data && res.data.success) {
                          var defer = $q.defer();
                          list[res.data.item.id] = defer.promise;
                          defer.resolve(res.data.item);
                      } else if (res.data) {
                        alert('上传错误,"+res.data.message');
                      }
                  }, function (error) {
                        alert("上传失败");
                  });
                  return p;
              },
              getById: function (id) {
                  if (list[id]) {
                      return list[id];
                  } else {
                      var defer = $q.defer();
                      list[id] = defer.promise;

                      $http({
                          "method": "GET",
                          // "url": dc_config.apiPath() + '/file/fileinfo/' + id
                            "url":'/file/fileinfo/' + id
                      }).then(function (res) {
                          if (res.data && res.data.success) {
                              defer.resolve(res.data.item);
                          } else {
                              defer.reject();
                          }
                      }, function (error) {
                          list[id] = null;
                          defer.reject(error);
                      });
                      return list[id];
                  }
              }
          };
      })
})();
